module.exports = __webpack_public_path__ + "media/images/vp/icon.pdf.bg.red-353ea20cdc3e7ef7a9add4b3b4279e8f.png";